export default __webpack_public_path__ + "static/media/img-0035.9a98403e.png";